import { useCallback } from "react";
import { useSaveDistributorTypeMutation } from "../mutations/useSaveDistributorType.mutation";
import { TDistributorTypeForm } from "../types/distributorTypes.types";

export const useSaveDistributorType = () => {
  const saveMutation = useSaveDistributorTypeMutation();

  const handleSave = useCallback(
    (values: TDistributorTypeForm) => saveMutation.mutate(values),
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
